import { IS_PROD } from './env'

export const SESSION_STORAGE_TOKEN_KEY = 'access_token'
export const COOKIE_UUID_KEY = 'userUuid'
export const APP_LINK = `https://app${!IS_PROD ? '-stage' : ''}.getthetrace.com`
export const TERMS_LINK = `/terms-of-use`
export const POLICY_LINK = `/privacy-policy`
export const COOKIE_POLICY_LINK = `/privacy-policy#cookies`
export const SUPPORT_LINK = 'https://getthetrace.zendesk.com/hc/en-us'
export const SUPPORT_EMAIL = 'support@getthetrace.com'
export const EBANX_BR_PAYMENT_TERMS_LINK =
  'https://www.ebanx.com/pt-br/legal/consumidores/brasil/termos-para-processar-pagamentos/'

export const STRIPE_ACCOUNT_FALLBACK = {
  CARD: 'CARD',
  PIX: 'PIX',
  BLIK: 'BLIK',
} as const

/**
 * Landings that pick their H1 from the ad's `utm_term` instead of the screen's
 * default title. A/B tested against `phone_lookup` / `name_lookup` /
 * `email_lookup`, which keep their current titles.
 */
export const KEYWORD_SCREEN_IDS = ['phone_lookup_kw', 'name_lookup_kw', 'email_lookup_kw'] as const
export type KeywordScreenId = (typeof KEYWORD_SCREEN_IDS)[number]

/** Only Google Ads traffic carries the `{keyword}` that the H1 map is built on. */
export const KEYWORD_H1_UTM_SOURCE = 'googleadwords_int'

export const FBC_PARAM = '_fbc'
export const FBP_PARAM = '_fbp'
export const TTP_PARAM = '_ttp'
export const DEFAULT_DELAY_TIME = 300
// export const GOOGLE_ADS_OB_START_ID = 'IeJACOr80pwbEJqgyZQB'
export const GOOGLE_ADS_LEAD_ID = '0es5CNjqv4IcEN2QnfxC'
export const GOOGLE_ADS_CONVERSION_ID = 'C1uKCPemx4IcEN2QnfxC'
export const GOOGLE_ADS_ACCOUNT_ID = '9203700535-WEB-TR'

export const UET_PURCHASE_GOAL = 'purchase'
export const BING_TRAFFIC_KEY = 'bingTraffic'

export const PREDICTED_LTV_VALUE = 30

export const EU_COUNTRIES_CODES = [
  'AT',
  'BE',
  'HR',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
]

export const CONSENT_REQUIRED_COUNTRIES = [
  // EU
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  // EEA, non-EU
  'IS',
  'LI',
  'NO',
  // UK + Switzerland
  'GB',
  'CH',
]

export const PAYMENT_GATEWAY_PROPERTY = 'Payment gateway'
export const PAYMENT_GATEWAY = {
  BRAINTREE: 'Braintree',
  stripe: (accountName?: string | null) => (accountName ? `Stripe [${accountName}]` : 'Stripe'),
} as const
export const SKIP_UPSELL_PAYMENT_METHODS = ['revolut_pay', 'blik', 'pix', 'pix_automatico', 'amazon_pay']
